import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import {
  EInfrastructureView,
  IRegularInfrastructureData,
  IRecommendationNewbuildingInfrastructure,
  TRegularInfrastructureItem,
  TRegularInfrastructureType,
} from '../../../types/map';
import { getConstructionYears, getMapYears } from '../../../utils/map';
import { getGeoObject, getLineStringGeoObject } from './getGeoObject';

export function getInfrastructureMapByYear(
  infrastructureItems: TRegularInfrastructureItem[],
  recommendationNewBuildings: IRecommendationNewbuildingInfrastructure[],
  main: IMapGeoObject,
  mainPolygon: IMapGeoObject | null,
  isFutureInfrastructureServiceVisible = false,
) {
  const map = new Map<number, IRegularInfrastructureData>();

  const years = getMapYears();

  years.forEach(year => {
    const futureTypes = new Set<TRegularInfrastructureType>();

    infrastructureItems.forEach(item => {
      if ('constructionYearFrom' in item) {
        // TODO: Одна из веток будет удалена в NB-1172
        if (isFutureInfrastructureServiceVisible) {
          if (item.constructionYearFrom <= year) {
            addItemToMap(item, year, map, EInfrastructureView.FutureObject);
            futureTypes.add(item.type);
          }

          return;
        }

        const constructionYears = getConstructionYears(item);

        if (constructionYears.includes(year)) {
          addItemToMap(item, year, map, EInfrastructureView.FutureObject);
          futureTypes.add(item.type);
        }

        return;
      }

      addItemToMap(item, year, map, EInfrastructureView.ExistingObject);
    });

    recommendationNewBuildings.forEach(item => addItemToMap(item, year, map, EInfrastructureView.ExistingObject));

    const currentYearGeoObjectsData = map.get(year)?.geoObjectsData || [];
    currentYearGeoObjectsData.push({ geoObject: main, infrastructureItem: null });

    if (mainPolygon) {
      currentYearGeoObjectsData.push({ geoObject: mainPolygon, infrastructureItem: null });
    }

    map.set(year, {
      geoObjectsData: currentYearGeoObjectsData,
      futureTypes: [...futureTypes],
    });
  });

  return map;
}

function addItemToMap(
  item: TRegularInfrastructureItem,
  year: number,
  map: Map<number, IRegularInfrastructureData>,
  view: EInfrastructureView,
) {
  const { type, coordinates, id } = item;

  const geoObjectsData = map.get(year)?.geoObjectsData || [];

  if (type === 'futureRoad') {
    const lineStringGeoObject = getLineStringGeoObject({
      name: type,
      coordinates: item.lineString,
      id: `${id}_line_string`,
    });
    const pontGeoObject = getGeoObject({ name: type, coordinates, id: `${id}_point`, view });

    geoObjectsData.push({
      geoObject: lineStringGeoObject,
      infrastructureItem: item,
    });
    geoObjectsData.push({
      geoObject: pontGeoObject,
      infrastructureItem: item,
    });
  } else {
    const geoObject = getGeoObject({ name: type, coordinates, id, view });

    geoObjectsData.push({
      geoObject,
      infrastructureItem: item,
    });
  }

  map.set(year, { geoObjectsData, futureTypes: [] });
}
